var exports = {
  "ig": "taskList__vbJBqd",
  "AS": "item__0w3Uac",
  "O0": "itemLeadingVisual__tWWRBH",
  "Oj": "taskTitle__DuKnFB",
  "Ir": "itemDescription__KBxDcF",
  "TN": "itemActions__cFS_ar",
  "WB": "prNumberButton__Y5LocG",
  "HU": "agentAvatarTrailingVisual__4EQmUN",
};

module.exports = exports;
